// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__119I4","list":"PatternAutocomplete_list__1BHwd"};